module.exports = __webpack_public_path__ + "static/media/vinefinder2.3b3f4368.png";